import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

@Component({
  components: {
  }
})
export default class Maintenance extends Vue { // 保养项目
  @Prop({ default: false }) readonly loading: Boolean
  @Prop({ default: () => ([]) }) readonly data: Array<any>
  @Prop({ default: false }) readonly canEdit: Boolean
  @Prop({ default: () => ([]) }) readonly maintainItemList: Array<any>

  dataSource = []
  count = 0

  @Watch('data')
  getdata(){
    this.dataSource = []
    if(this.data && this.data.length > 0){
      this.data.forEach((res, index ) =>{
        if(this.canEdit){
          const item ={
            key: index,
            id: res.itemId,
            code: res.itemCode,
            name: res.itemName,
            requirement: res.itemRequirement,
            remark: res.itemRemark,
          }
          this.dataSource.push(item)
        } else {
          const item = {...res}
          item.key = index
          this.dataSource.push(item)
        }
      })
      this.count = this.data.length
    }
  }

  get subColumns() {
    return [
      { title: this.$t('page_plan_maintenance_code'), dataIndex: 'code', width: 150, ellipsis: true,
      // customRender: (text, record) => {
      //   return (
      //     <a-select value={text} disabled={!this.canEdit} onChange={e => this.handleChange(e, record.key)} style="width: 100%;">
      //     { this.maintainItemList.map(res => {
      //       return (
      //         <a-select-option value={res.code}>
      //           { res.code }
      //         </a-select-option>
      //       )
      //     }) }
      //     </a-select>
      //   )
      // }
      },
      { title: this.$t('page_plan_maintenance_items'), dataIndex: 'name', width: 200, ellipsis: true },
      { title: this.$t('page_plan_maintenance_requirements'), dataIndex: 'requirement', width: 100, ellipsis: true },
      { title: this.$t('remark'), dataIndex: 'remark', width: 200, ellipsis: true }
    ]
  }

  handleChange(value, key){
    const has = this.dataSource.find(res => res.code === value)
    if(has != undefined){
      this.$message.warning(this.$t('page_plan_maintenance_not_choose_same'))
      return
    }
    const newData = [...this.dataSource];
    const target = newData.filter(item => key === item.key)[0];
    const data = this.maintainItemList.find(res => res.code === value)
    if (target && data) {
      target['id'] = data.id;
      target['code'] = value;
      target['name'] = data.name;
      target['requirement'] = data.requirement;
      target['remark'] = data.remark;
      this.dataSource = newData;
      this.$emit('change',this.dataSource)
    }
  }

  handleAdd() {
    const { count, dataSource } = this;
    const newData = {
      key: count,
      code: "",
      name: "",
      requirement: "",
      remark: "",
    };
    this.dataSource = [...dataSource, newData];
    this.count = count + 1;
  }

  render() {
    return (
      <div style="height: 260px;">
        <ml-table
          size="small"
          defaultExpandAllRows={true}
          canChangeColWidth={true}
          loading={this.loading}
          dataSource={this.dataSource}
          columns={this.subColumns}
          scroll={{ y: 200 }}
        ></ml-table>
        {/* {this.canEdit ? <a-button type="primary"  style="width: 100%;margin-top: 8px;" onClick={() => this.handleAdd()}>添加保养项</a-button> : null}  */}
      </div>
    )
  }
}
